module.exports = __webpack_public_path__ + "0a775cbf20c57d57fbd3c72f59b9c08d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Wechat1.svg
// module id = ASFD
// module chunks = 3